export default __webpack_public_path__ + "static/media/status_active.0095f05b.svg";